var AboutUsEnum = /* @__PURE__ */ ((AboutUsEnum2) => {
  AboutUsEnum2["ABOUT_US_YOUTUBE_EMBED"] = "about-us--youtube-embed";
  AboutUsEnum2["ABOUT_US_SCHEDULE_NOW_BUTTON"] = "about-us--schedule-now-button";
  return AboutUsEnum2;
})(AboutUsEnum || {});
export {
  AboutUsEnum
};
